<template>
    <Dialog :visible="visible" @update:visible="$emit('update:visible', $event)" :modal="true"
            :header="title" :style="{width: '640px'}" :breakpoints="{'960px': '90vw'}" class="p-fluid">
        <div v-if="askLabel" class="field mb-3">
            <label for="rt-label">Nombre de la cuenta</label>
            <InputText id="rt-label" v-model="labelValue" placeholder="Ej. Grupo Ricardo, Barra, Para llevar" />
        </div>

        <span class="p-input-icon-left mb-3" style="width: 100%;">
            <i class="pi pi-search" />
            <InputText v-model="filter" placeholder="Buscar producto..." style="width: 100%;" @input="onSearch" />
        </span>

        <div class="rt-menu-list">
            <div v-if="loading" class="rt-empty">Cargando menú...</div>
            <div v-else-if="!products.length" class="rt-empty">No hay productos para vender.</div>
            <div v-for="p in products" :key="p.id" class="rt-menu-row">
                <div class="rt-menu-info">
                    <span class="rt-menu-name">{{ p.name }}</span>
                    <span class="rt-menu-price">${{ money(p.price) }}</span>
                </div>
                <div class="rt-stepper">
                    <Button icon="pi pi-minus" class="p-button-rounded p-button-text p-button-sm"
                            :disabled="!qty[p.id]" @click="step(p, -1)" />
                    <span class="rt-qty">{{ qty[p.id] || 0 }}</span>
                    <Button icon="pi pi-plus" class="p-button-rounded p-button-text p-button-sm"
                            @click="step(p, 1)" />
                </div>
            </div>
        </div>

        <template #footer>
            <div class="flex align-items-center justify-content-between">
                <span class="rt-foot-summary">{{ selectedCount }} ítem(s) · ${{ money(selectedTotal) }}</span>
                <span>
                    <Button label="Cancelar" class="p-button-text" @click="$emit('update:visible', false)" />
                    <Button :label="confirmLabel" icon="pi pi-check" :disabled="!selectedCount || saving"
                            :loading="saving" @click="confirm" />
                </span>
            </div>
        </template>
    </Dialog>
</template>

<script>
import httpRequest from '../../service/httpRequest';

export default {
    name: 'ProductPickerDialog',
    props: {
        visible: { type: Boolean, default: false },
        askLabel: { type: Boolean, default: false },
        title: { type: String, default: 'Agregar ítems' },
        confirmLabel: { type: String, default: 'Agregar' },
        saving: { type: Boolean, default: false },
    },
    emits: ['update:visible', 'confirm'],
    data() {
        return {
            products: [],
            filter: '',
            qty: {},
            labelValue: '',
            loading: false,
            searchTimer: null,
        };
    },
    computed: {
        selectedCount() {
            return Object.values(this.qty).reduce((n, v) => n + (Number(v) || 0), 0);
        },
        selectedTotal() {
            return this.products.reduce((sum, p) => sum + (this.qty[p.id] || 0) * Number(p.price || 0), 0);
        },
    },
    watch: {
        visible(open) {
            if (open) {
                this.qty = {};
                this.labelValue = '';
                this.filter = '';
                this.loadProducts();
            }
        },
    },
    methods: {
        money(value) {
            return Number(value || 0).toFixed(2);
        },
        async loadProducts() {
            this.loading = true;
            // sellableOnly: la venta no ofrece insumos (mismo criterio que saleForm/orders).
            const res = await httpRequest.getProducts(this.filter || null, null, true, true);
            this.loading = false;
            this.products = (res && res.status === 200 && Array.isArray(res.data)) ? res.data : [];
        },
        onSearch() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.loadProducts(), 250);
        },
        step(product, delta) {
            const current = this.qty[product.id] || 0;
            const next = Math.max(0, current + delta);
            this.qty = { ...this.qty, [product.id]: next };
        },
        confirm() {
            const items = Object.entries(this.qty)
                .filter(([, amount]) => Number(amount) > 0)
                .map(([productId, amount]) => ({ productId: Number(productId), amount: String(amount) }));
            if (!items.length) return;
            this.$emit('confirm', { label: (this.labelValue || '').trim(), items });
        },
    },
};
</script>

<style scoped>
.rt-menu-list { max-height: 340px; overflow-y: auto; border: 1px solid var(--surface-border); border-radius: 8px; }
.rt-menu-row { display: flex; align-items: center; justify-content: space-between; padding: 0.5rem 0.75rem; border-bottom: 1px solid var(--surface-border); }
.rt-menu-row:last-child { border-bottom: none; }
.rt-menu-info { display: flex; flex-direction: column; }
.rt-menu-name { font-weight: 600; }
.rt-menu-price { color: var(--text-color-secondary); font-size: 0.85rem; }
.rt-stepper { display: flex; align-items: center; gap: 0.25rem; }
.rt-qty { min-width: 1.5rem; text-align: center; font-weight: 700; }
.rt-empty { padding: 1.5rem; text-align: center; color: var(--text-color-secondary); }
.rt-foot-summary { color: var(--text-color-secondary); font-size: 0.9rem; }
</style>
